import { render, staticRenderFns } from "./SingleRooms.vue?vue&type=template&id=25e1c85c&lang=pug&"
import script from "./SingleRooms.vue?vue&type=script&lang=js&"
export * from "./SingleRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports